module.exports = __webpack_public_path__ + "img/spring_trip-20160416-2-768x1024.bc160b42.jpg";